/* eslint-disable */

const checkConnection = () => {
  var networkState = navigator.connection.type;

  if (!networkState || ['unknown', 'none'].indexOf(networkState) > -1 && !window.navigator.onLine) return false;

  return true
}

const isOnline = () => {
  if (typeof cordova !== "undefined") {
    return checkConnection()
  } else {
    if (typeof window.navigator.onLine === 'undefined') return true;
    else return window.navigator.onLine;
  }
};

export {isOnline}
